<div class="row" data-testid="subscribe-emails-container">
  <div class="col-12 col-md-6">
    <div class="dx-field mb-2">
      <dx-check-box
        text="Monthly Executive Summary"
        [(value)]="emailList.monthly_executive"
        [elementAttr]="{ 'data-testid': 'subscribe-emails-checkbox-monthly' }"
      ></dx-check-box>
    </div>
    <div class="dx-field mb-2">
      <dx-check-box
        text="Weekly Marketplace Changes (Fridays)"
        [(value)]="emailList.weekly_changes"
        [elementAttr]="{ 'data-testid': 'subscribe-emails-checkbox-weekly-changes' }"
      ></dx-check-box>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="dx-field mb-2">
      <dx-check-box
        text="Favorite Items Alert"
        [(value)]="emailList.fav_listings"
        [elementAttr]="{ 'data-testid': 'subscribe-emails-checkbox-favorites' }"
      ></dx-check-box>
    </div>
    <div class="dx-field mb-2">
      <dx-check-box
        text="Weekly News / Trending Products (Tuesdays)"
        [(value)]="emailList.trending_products"
        [elementAttr]="{ 'data-testid': 'subscribe-emails-checkbox-trending' }"
      ></dx-check-box>
    </div>
  </div>
</div>
